import(/* webpackMode: "eager", webpackExports: ["BaseTemplate"] */ "/app/src/templates/BaseTemplate.tsx");
